// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';


const getContactData = contextConfiguration => axios.get(
	'/contact_data',
	{
		...commonConfiguration,
		...contextConfiguration,
	}
).catch(onRequestError);

export default getContactData;
